import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';

import ProgressBar from '../../Shared/ProgressBar/progressBar';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {clearStateHistoryAction} from '../../../utilities/stateHistory/stateHistorySlice';
import CreditCardAlert from '../../Shared/CreditCardAlert/CreditCardAlert';

//store functions
import {
  initSale,
  resetBlock,
  reportDWH,
  setFlowType,
  setPersonalInfo,
  setPackageNotValidPopUp,
  setShowPopUpRouter,
  syncPageNavigationState,
  clearAutoPrepareSale,
} from './saleJetBlockSlice';
import {resetSalePackagesBlock} from '../SalePackagesBlock/salePackagesBlockSlice';
import PackageBar from './Partials/PackageBar/PackageBar';
import { isStepBarPage } from './Partials/PackageBar/saleStepBarHelpers';
import StickyBar from './Partials/Cellular/StickyBar/StickyBar';

//pages
import PackagesPage from './Pages/PackagesPage';
import AddressPage from './Pages/AddressPage';
import LeadPage from './Pages/LeadPage';
import LoginPage from './Pages/LoginPage';
import CellularSettingsPage from './Pages/CellularSettingsPage';
import LoginSuccessPage from './Pages/LoginSuccessPage';
import RouterPage from './Pages/RouterPage';
import SuperWifiPage from './Pages/SuperWifiPage';
import TechnicianPage from './Pages/TechnicianPage';
import PavingFeePage from './Pages/PavingFeePage';
import UserAddressPage from './Pages/UserAddressPage';
import UserAddressForUpgradePage from './Pages/UserAddressForUpgradePage';
import EmailPage from './Pages/EmailPage';
import CreateSaleInProcess from './Pages/CreateSaleInProcess';
import SuccessPage from './Pages/SuccessPage';
import OtpVerifyCodePage from './Pages/OtpVerifyCodePage';
import PaymentPage from './Pages/PaymentPage';
import PersonalInfoPage from './Pages/PersonalInfoPage';
import ConvertersPage from './Pages/ConvertersPage';
import PremiumPackagesPage from './Pages/PremiumPackagesPage';
import ViewingOptionPage from './Pages/ViewingOptionPage';
import DeliveryAddressPage from './Pages/DeliveryAddressPage';
import DeliveryPage from './Pages/DeliveryPage';
import ErrorPage from './Pages/ErrorPage';
import AddTechnicianContact from './Partials/AddTechnicianContact/AddTechnicianContact';
import SummaryPage from './Pages/SummaryPage';
import AddonsPage from './Pages/AddonsPage';
import InternetCustomerInfoPage from './Pages/InternetCustomerInfoPage';
import InternetPaymentDigitsPage from './Pages/InternetPaymentDigitsPage';
import InternetExistingPaymentPage from './Pages/InternetExistingPaymentPage';
import CellularChooseLineToActivatePage from './Pages/CellularChooseLineToActivatePage';
import PopUp from '../../Shared/Popup/PopUp';
import InternetIdentitySuccessPopup from './Partials/InternetIdentitySuccessPopup/InternetIdentitySuccessPopup';
import InternetExistingInternetChoicePopup from './Partials/InternetExistingInternetChoicePopup/InternetExistingInternetChoicePopup';
import GeneralMessage from '../../Page/OrganizationEmloyeePage/GeneralMessage';
import {isOrgEmployeeLogin} from '../OTPLoginBlock/Assets/variables';
import {setShowPopup} from '../../Page/OrgEmployeeFamilySalePage/OrgEmployeeFamilySaleSlice';
import { buildUrlAndNavigate } from '../../../utilities/StringHelpers/StringHelpers';

//images
import image from './images/pop_up.svg';
import {PopUpRouterWifi} from './Partials/PopUpRouterWifi/PopUpRouterWifi';
import {addRouterWifiStarPro, prepareSaleAsync} from './saleBlockAsyncThunk';
const Sale = (props) => {
  let currentView = null;
  const isOrgEmployeeFamilyMember = isOrgEmployeeLogin(props._authentication);

  const showESimStickyBar = props.saleType == 'cellular' && props.page != 'cellularSettingsPage' && props.isSelectedEsim && props.esimStickyTag?.value;
  //--------------- useEffect ---------------
  useExtendedEffect((runSideEffects) => {
    const isFullAuthenticated = props._authentication.loginData.isFullAuthenticated;
    if (runSideEffects()) {
      props.initSale({ saleJetBlock: props.iContent, salePackage: props._selectedPackage, addressPage: props._addressPage, isFullAuthenticated: isFullAuthenticated });
      //props.reportDWH({ actionType: 'New Sale', status: 'Ongoing', messageText: 'start new sale' });
    }else{
        if(props.page == ''){
            props.initSale({ saleJetBlock: props.iContent, salePackage: props._selectedPackage, addressPage: props._addressPage, isFullAuthenticated: isFullAuthenticated });
        }
    }
    return () => {
      if (runSideEffects()) {
        props.resetBlock();
        props.resetSalePackagesBlock();
      }
    };
  }, []);

  useClearStateResetFlag();

  useEffect(() => {
    if (props._authentication.loginData.isFullAuthenticated) {
      props.setFlowType('existsCustomer');
      const personalInfo = {
        isCustomerExists: true,
        identity: props._authentication.loginData.userDetails.IDNumber,
        subscriberNo: props._authentication.loginData.userDetails.contactNumber,
        firstName: props._authentication.loginData.userDetails.firstName,
        lastName: props._authentication.loginData.userDetails.lastName,
      };
      props.setPersonalInfo(personalInfo);
    }
  }, [props._authentication.loginData.isFullAuthenticated]);
  useEffect(() => {
    if (props.autoPrepareSale) {
      props.clearAutoPrepareSale();
      props.prepareSaleAsync();
    }
  }, [props.autoPrepareSale]);

  useEffect(() => {
    if (props.page && props.saleType) {
      props.syncPageNavigationState();
    }
  }, [props.page, props.saleType, props.flowType]);

  //--------------- useEffect ---------------

  switch (props.page) {
    case 'packagesPage': currentView = <PackagesPage  iContent={ props.iContent}/>; break;
    case 'addressPage': currentView = <AddressPage context={props.context} />; break;
    case 'leadPage': currentView = <LeadPage />; break;
    case 'loginPage': currentView = <LoginPage />; break;
    case 'cellularSettingsPage': currentView = <CellularSettingsPage context={props.context} />; break;
    case 'loginSuccessPage': currentView = <LoginSuccessPage />; break;
    case 'routerPage': currentView = <RouterPage />; break;
    case 'superWifiPage': currentView = <SuperWifiPage />; break;
    case 'technicianPage': currentView = <TechnicianPage />; break;
    case 'pavingFeePage': currentView = <PavingFeePage />; break;
    case 'userAddressPage': currentView = <UserAddressPage />; break;
    case 'userAddressForUpgradePage': currentView = <UserAddressForUpgradePage />; break;
    case 'emailPage': currentView = <EmailPage context={props.context}/>; break;
    case 'createSaleInProcess': currentView = <CreateSaleInProcess />; break;
    case 'successPage': currentView = <SuccessPage />; break;
    case 'otpVerifyCode': currentView = <OtpVerifyCodePage />; break;
    case 'paymentPage': currentView = <PaymentPage />; break;
    case 'personalInfoPage': currentView = <PersonalInfoPage />; break;
    case 'convertersPage': currentView = <ConvertersPage />; break;
    case 'premiumPackagesPage': currentView = <PremiumPackagesPage context={props.context} />; break;
    case 'viewingOptionPage': currentView = <ViewingOptionPage />; break;
    case 'deliveryAddressPage': currentView = <DeliveryAddressPage />; break;
    case 'deliveryPage': currentView = <DeliveryPage />; break;
    case 'errorPage': currentView = <ErrorPage />; break;
    case 'addTechnicianContact': currentView = <AddTechnicianContact />; break;
    case 'summaryPage': currentView = <SummaryPage />; break;
    case 'addonsPage': currentView = <AddonsPage />; break;
    case 'internetCustomerInfoPage':
      currentView = props.saleType === 'internet' ? <InternetCustomerInfoPage /> : <TechnicianPage />;
      break;
    case 'internetPaymentDigitsPage': currentView = <InternetPaymentDigitsPage />; break;
    case 'internetExistingPaymentPage': currentView = <InternetExistingPaymentPage />; break;
    case 'cellularChooseLineToActivatePage': currentView = <CellularChooseLineToActivatePage />; break;
  }

  function handleCloseInfoPopup() {
    props.setPackageNotValidPopUp(false);
  }

  const showStepperBar = props.stepBar?.show || isStepBarPage(props.page);
  const hideProgressTracker = props.saleType === 'internet';
  const hidePackageBar = props.saleType === 'internet' && props.page === 'addressPage';



  return (
    <>
      {!showStepperBar && !hideProgressTracker && (
        <ProgressBar points={props.progressBarPoints} percent={props.percent} />
      )}
      {showESimStickyBar && <StickyBar text={props.esimStickyTag?.value} />}
      {props.saleType != 'cellular' && props.page != 'packagesPage' && !hidePackageBar && (
        <PackageBar
          showStepper={showStepperBar}
          packageName={showStepperBar ? undefined : props.selectedPackage.title}
        />
      )}
      {currentView}
      <InternetIdentitySuccessPopup />
      <InternetExistingInternetChoicePopup />
      {props.page === 'addressPage' && <CreditCardAlert link={props.creditIndicatorLink} title={props.creditIndicatorTitle} />}
      <PopUp
        className='package-not-valid-popup'
        showPopUp={props.packageNotValidPopUp}
        onClose={() => handleCloseInfoPopup()}
        footerBtn={{text: 'בואו נעשה את זה ', onBtnClick: handleCloseInfoPopup}}>
        <Image src={image} alt='image pop-up' />
        <h1>
          התוכנית שבחרתם לא נתמכת <br></br> בתשתית הקיימת בכתובת
        </h1>
        <p>אבל זה לא סיפור בכלל, אפשר להתקדם ולבחור חבילות מעולות שמתאימות במיוחד לתשתית הקיימת בכתובת שלכם.</p>
      </PopUp>

      {isOrgEmployeeFamilyMember  && (
        <PopUp className='mainPopup' showPopUp={props.showOrgFamilySalePopup} onClose={() =>{ 
          props.setShowPopup(false);}}>
            <GeneralMessage  messageData={props.messageData} data={props.orgEmployeeFamilySale} setShowPopup={props.setShowPopup}  />
        </PopUp>
      )}


      {props.isShowPopUpRouterSlice && props.isShowPopUpEpi?.value && (
        <PopUpRouterWifi
          saleType={props.saleType}
          flowType={props.flowType}
          routerInfo={props.routerInfo}
          setShowPopUpRouter={props.setShowPopUpRouter}
          isShowPopUpRouterSlice={props.isShowPopUpRouterSlice}
          addRouterWifiStarPro={props.addRouterWifiStarPro}
          reportDWH={props.reportDWH}></PopUpRouterWifi>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    page: state.saleJetBlock.page,
    stepBar: state.saleJetBlock.stepBar,
    percent: state.saleJetBlock.percent,
    progressBarPoints: state.saleJetBlock.progressBarPoints,
    creditIndicatorLink: state.saleJetBlock.saleBlockData?.creditIndicatorLink,
    creditIndicatorTitle: state.saleJetBlock.saleBlockData?.creditIndicatorTitle,
    esimStickyTag: state.saleJetBlock.saleBlockData?.esimData?.headerRemark,
    selectedPackage: state.saleJetBlock.selectedPackage,
    isSelectedEsim: state.saleJetBlock.cellular.isSelectedEsim,
    packageNotValidPopUp: state.saleJetBlock.packageNotValidPopUp,
    isShowPopUpEpi: state.saleJetBlock.selectedPackage.isShowPopUpEpi,
    routerInfo: state.saleJetBlock.selectedPackage.routerInfo,
    flowType: state.saleJetBlock.flowType,
    routers: state.saleJetBlock.saleCatalog.routers,
    isShowPopUpRouterSlice: state.saleJetBlock.isShowPopUpRouterSlice,
    autoPrepareSale: state.saleJetBlock.autoPrepareSale,
    //other states
    _addressPage: state.checkFiberInfrastructureBlock.addressPage,
    _selectedPackage: state.SalePackagesBlock.selectedPackage,
    _authentication: state.authentication,
    showOrgFamilySalePopup: state.orgEmployeeFamilySale.showPopup,
    messageData: state.orgEmployeeFamilySale.messageData,
    orgEmployeeFamilySale: state.orgEmployeeFamilySale,
  };
};

const mapDispatchToProps = {
  initSale,
  resetBlock,
  resetSalePackagesBlock,
  reportDWH,
  setFlowType,
  setPersonalInfo,
  clearStateHistoryAction,
  setPackageNotValidPopUp,
  setShowPopUpRouter,
  syncPageNavigationState,
  addRouterWifiStarPro,
  clearAutoPrepareSale,
  prepareSaleAsync,
  setShowPopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(Sale);
